import React from 'react'
import { toast } from 'react-toastify';

const ImageUpload = ({ title, handleFloorImagesUpload, previewUrl }) => {
    const handleFileChange = (event) => {
        const file = event.currentTarget.files[0];
        if (file) {
            const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
            if (!allowedTypes.includes(file.type)) {
                toast.error("Format not supported. Please use JPG, PNG or WebP.");
                event.target.value = "";
                return;
            }
            if (file.size > 10 * 1024 * 1024) { // 10MB
                toast.error("File is too large. Maximum size is 10MB.");
                event.target.value = "";
                return;
            }
            handleFloorImagesUpload(event);
        }
    };

    return (
        <div className="flex flex-col gap-2">
            <label className="block text-sm font-medium text-gray-900 dark:text-white">
                {title}<span className="text-red-500">*</span>
            </label>
            {previewUrl && (
                <div className="relative w-full h-32 mb-1 rounded-lg overflow-hidden border border-gray-200">
                    <img src={previewUrl} alt={title} className="w-full h-full object-cover" />
                    <div className="absolute top-0 right-0 bg-black bg-opacity-50 text-white text-[10px] px-1.5 py-0.5">
                        Current
                    </div>
                </div>
            )}
            <input
                className="block w-full text-xs text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                type="file"
                accept="image/jpeg,image/png,image/webp,image/jpg"
                onChange={handleFileChange}
            />
            <p className="text-[10px] text-gray-500 -mt-1">
                Accepted formats: JPG, PNG, WebP (Max. 10MB)
            </p>
        </div>
    )
}

export default ImageUpload